import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { NUMBER_SIZE } from '../../../constants/size'
import { FileIconPreview } from '../../FileIcon'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'

import * as styles from './FileListItemContent.module.css'

function FileListItemContent({ isHovered, showTooltip, value }) {
  const { is_persistent: isPersistent, label } = value

  const { t } = useTranslation()

  const textClassName = classNames(styles.text, { [styles.hover]: isHovered })

  const optionText = isPersistent ? t(label?.filename) : label?.filename

  return (
    <>
      {label.mime_type ? (
        <FileIconPreview file={label} size={NUMBER_SIZE.size24} />
      ) : null}
      <FloatingTooltip content={optionText} disabled={!showTooltip}>
        <Text className={textClassName}>{optionText}</Text>
      </FloatingTooltip>
    </>
  )
}

export default FileListItemContent
